import { useAction, useAtom } from '@reatom/npm-react'
import styled, { css } from 'styled-components'

import { useHapticFeedback } from '@blade/ui-kit'
import { CurrencyIcon } from '@root/entities/currency/ui'
import { PairInformationCurrency } from '@root/entities/pair/ui'
import { FavoriteStar } from '@root/features/favorite-pairs/ui/common'
import { tradingPairAtom } from '@root/features/trade/trading'
import { pairViewAtom, togglePairViewAction } from '@root/screens/trading/atoms'

import { TradingPairHeaderSkeleton } from './trading-pair-header-skeleton'
import { TradingPairHeaderToggle } from './trading-pair-header-toggle'

type TradingPairHeaderProps = {}

export const TradingPairHeader: React.FC<TradingPairHeaderProps> = () => {
  const haptics = useHapticFeedback()
  const togglePairView = useAction(togglePairViewAction)
  const [pairView] = useAtom(pairViewAtom)
  const [activePair] = useAtom(tradingPairAtom)

  if (!activePair) {
    return <TradingPairHeaderSkeleton />
  }

  return (
    <Root
      $isOpen={pairView === 'details'}
      onClick={() => {
        haptics.impactOccurred('light')
        togglePairView()
      }}
    >
      <CurrencyIcon
        size={34}
        currency={activePair.quote}
        withNetwork
        auxIconSize={12}
        css={css`
          margin-inline-end: 8px;
        `}
      />
      <PairInformationCurrency
        pair={activePair}
        withProvider
        withAge
        withSocials
      />
      <FavoriteContainer>
        <FavoriteStar size={16} pair={activePair} />
      </FavoriteContainer>
      <TradingPairHeaderToggle />
    </Root>
  )
}

const Root = styled.div<{ $isOpen: boolean }>`
  padding-inline: 12px 0px;
  height: 55px;
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: auto minmax(0, 1fr) auto auto;
  align-items: center;
  justify-items: start;

  background: ${(props) =>
    props.$isOpen ? 'var(--appearance-1)' : 'var(--background-1)'};
  border-top: 1px solid var(--background-3);
  border-bottom: 1px solid var(--background-3);

  transition: background 0.3s;
`

const FavoriteContainer = styled.div`
  padding-inline-end: 8px;
  padding-top: 8px;
  align-self: start;
`
